import * as THREE from "../../libs/three2";


export const threeFonts = {
    "HappyZcool": new THREE.Font({
        underlineThickness: 64,
        boundingBox: {
            yMin: -211,
            xMin: -60,
            yMax: 1213,
            xMax: 1407
        },
        resolution: 1000,
        glyphs: {}
    }),
    "SetoFont": new THREE.Font({
        "glyphs":{},
        "familyName":"SetoFont",
        "ascender":1194,
        "descender":-195,
        "underlinePosition":-130,
        "underlineThickness":65,
        "boundingBox":{"yMin":-1021,"xMin":-656,"yMax":1198,"xMax":2694},
        "resolution":1000,
        "original_font_information":{"format":0,"copyright":"Nozomi Seto","fontFamily":"SetoFont","fontSubfamily":"Regular","uniqueID":"SetoFont","fullName":"SetoFont","version":"Version 6.16","postScriptName":"SetoFont","trademark":"SetoFont"},
        "cssFontWeight":"normal","cssFontStyle":"normal"
    }),
    "SoukouMincho": new THREE.Font({
        "glyphs":{},
        "familyName":"SoukouMincho",
        "ascender":1222,
        "descender":-167,
        "underlinePosition":-104,
        "underlineThickness":69,
        "boundingBox":{"yMin":-389,"xMin":-222,"yMax":1389,"xMax":1639},
        "resolution":1000,
        "original_font_information":{"format":0,"copyright":"Adobe Systems Incorporated","fontFamily":"SoukouMincho","fontSubfamily":"Regular","uniqueID":"SoukouMincho","fullName":"SoukouMincho","version":"Version 1.00","postScriptName":"SoukouMincho","trademark":"SoukouMincho","manufacturer":"Adobe Systems Incorporated","designer":"Dr. Ken Lunde (project architect, glyph set definition & overall production); Masataka HATTORI 服部正貴 (production & ideograph elements)","description":"Dr. Ken Lunde (project architect, glyph set definition & overall production); Masataka HATTORI 服部正貴 (production & ideograph elements)","manufacturerURL":"http://www.flopdesign.com/","designerURL":"http://www.adobe.com/type/","licence":"This Font Software is licensed under the SIL Open Font License, Version 1.1. This Font Software is distributed on an \"AS IS\" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the SIL Open Font License for the specific language, permissions and limitations governing your use of this Font Software.","licenceURL":"http://scripts.sil.org/OFL","preferredFamily":"SoukouMincho","preferredSubfamily":"Regular","compatibleFullName":"\\u88C5 \\u7532 \\u660E \\u671D "},
        "cssFontWeight":"normal","cssFontStyle":"normal"
    }),
    "TW-Kai": new THREE.Font({
        "glyphs":{},
        "familyName":"TW-Kai",
        "ascender":1112,
        "descender":-277,
        "underlinePosition":-149,
        "underlineThickness":68,
        "boundingBox":{"yMin":-281,"xMin":-39,"yMax":1112,"xMax":1401},
        "resolution":1000,
        "original_font_information":{"format":0,"copyright":"(c)2015國家發展委員會。依政府資料開放授權條款(http://data.gov.tw/license)","fontFamily":"TW-Kai","fontSubfamily":"Regular","uniqueID":"TW-Kai : 22-7-2013","fullName":"TW-Kai","version":"Version 103.1","postScriptName":"TW-Kai-98_1"},
        "cssFontWeight":"normal","cssFontStyle":"normal"
    }),
    "zcool-gdh": new THREE.Font({
        "glyphs":{},
        "familyName":"zcool-gdh",
        "ascender":1194,
        "descender":-196,
        "underlinePosition":-118,
        "underlineThickness":64,
        "boundingBox":{"yMin":-196,"xMin":-11,"yMax":1194,"xMax":1444},
        "resolution":1000,
        "original_font_information":{"format":0,"copyright":"zcool","fontFamily":"zcool-gdh","fontSubfamily":"Regular","uniqueID":"huxiaobo-gdh","fullName":"zcool-gdh","version":"Version 2.010","postScriptName":"zcool-gdh","trademark":"zcool"},
        "cssFontWeight":"normal",
        "cssFontStyle":"normal"
    }),
    "zcoolqingkehuangyouti": new THREE.Font({
        "glyphs":{},
        "familyName":"zcoolqingkehuangyouti",
        "ascender":1186,
        "descender":-425,
        "underlinePosition":-729,
        "underlineThickness":69,
        "boundingBox":{"yMin":-389,"xMin":-694,"yMax":1117,"xMax":1508},
        "resolution":1000,
        "original_font_information":{"format":0,"copyright":"(c) 2018 zcool.All rights reserved.","fontFamily":"zcoolqingkehuangyouti","fontSubfamily":"Regular","uniqueID":"zcoolqingkehuangyouti-Regular","fullName":"zcoolqingkehuangyouti-Regular","version":"Version 3.000","postScriptName":"zcoolqingkehuangyouti-Regular","trademark":"Trademark of zcool","manufacturer":"zqk","designer":"郑庆科","manufacturerURL":"http://www.zcool.com.cn/"},
        "cssFontWeight":"normal",
        "cssFontStyle":"normal"
    })
    //不支持该字体：可能只是不支持那些字，有的文字支持有点文字不支持，因为有些字体是只能适合那些文字，其余的文字都不适合
};

export const fontsDisp = [
    {
        fontNameDisp: '快乐站酷',
        fontName: 'HappyZcool',
    },
    {
        fontNameDisp: 'SetoFont',
        fontName: 'SetoFont',
    },
    {
        fontNameDisp: '正楷',
        fontName: 'TW-Kai',
    },
    {
        fontNameDisp: '站酷高端黑',
        fontName: 'zcool-gdh',
    },
    {
        fontNameDisp: '站酷庆科黄油体',
        fontName: 'zcoolqingkehuangyouti',
    },
    {
        fontNameDisp: '装甲明朝体',
        fontName: 'SoukouMincho',
    },
];


// 加载缺失的glyphs
export async function loadFontGlyphs(vue, fontName, chars) {
    let glyphs = threeFonts[fontName].data.glyphs;
    let left_chars = "";
    for (let i = 0; i < chars.length; i++) {
        let ch = chars.charAt(i);
        if (!(ch in glyphs)) {
            left_chars += ch;
        }
    }

    if (left_chars.length > 0) {
        return vue.$request.post("/textGlyphs/getTextGlyphs", {
            text: left_chars,
            font: fontName
        }).then(res => {
            let newGlyphs = res.obj;
            for (let ch in newGlyphs) {
                glyphs[ch] = newGlyphs[ch];
            }
            console.log(newGlyphs);
        });
    } else {
        console.log("all glyphs exists");
        return;
    }
}




// WEBPACK FOOTER //
// ./src/3dapps/js/fontUtils.js